import classNames from 'classnames';
import { forwardRef } from 'react';
import { MoreOptions } from './more_options';
import { CalendarInvitationSection, EmailCancellationSection, EmailConfirmationSection, EmailFollowUpSection, EmailRemindersSection, TextRemindersSection } from './notifications';
const sectionDetailContainerCss = "ssuot84";
const SectionDetailContainer = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(sectionDetailContainerCss, props.className)} />;
});
const Section = ({
  selectedSection,
  ...props
}) => {
  switch (selectedSection) {
    case 'more_options':
      return <MoreOptions {...props} />;
    case 'calendar_invitation':
      return <CalendarInvitationSection {...props} />;
    case 'email_cancellation':
      return <EmailCancellationSection {...props} />;
    case 'email_confirmation':
      return <EmailConfirmationSection {...props} />;
    case 'email_reminders':
      return <EmailRemindersSection {...props} />;
    case 'text_reminders':
      return <TextRemindersSection {...props} />;
    case 'email_follow_up':
      return <EmailFollowUpSection {...props} />;
    default:
      return <h1>
          Not yet implemented:
          {selectedSection}
        </h1>;
  }
};
export const SectionDetail = ({
  sectionKey,
  ...props
}) => <SectionDetailContainer>
    <Section selectedSection={sectionKey} {...props} />
  </SectionDetailContainer>;

require("./section_detail.wyw-in-js.css!=!../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./section_detail.js");